import React from 'react';
import { UserTypeValues } from 'shared-pages';
import { useRootStore } from 'store';
import { Dashboard } from './dashboard';

export const SwitchDashboard = () => {
  const { appStore, authStore } = useRootStore();

  let component = <></>;
  switch (appStore.usertypeId) {
    case UserTypeValues.PlatformOwner:
      component = <Dashboard />;
      break;
    case UserTypeValues.Collector:
      component = <Dashboard />;
      break;
    case UserTypeValues.CollectionPoint:
      component = <Dashboard />;
      break;
    default:
      component = <></>;
  }
  return component;
};
